import React from "react";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import { RootState } from "../../app/store";
import { useAppSelector, useAppDispatch } from "../../app/hooks";
import { updateSelectedPrompt } from "../../app/promptsSlice";

function ExcludeFormControl() {
  const dispatch = useAppDispatch();
  const toExclude = useAppSelector(
    (state: RootState) => state.prompts.selectedPrompt.toExclude
  );

  const handleChange = (
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    const newToExclude = event.target.value;
    dispatch(updateSelectedPrompt({ toExclude: newToExclude }));
  };

  return (
    <Box>
      <FormControl fullWidth>
        <TextField
          multiline
          id="exclude-textfield"
          rows={2}
          label="Exclude from output"
          slotProps={{ inputLabel: { shrink: true } }}
          placeholder='e.g. "Realm", "Delve", "Tapestry"'
          helperText="Add values separated by a comma"
          variant="outlined"
          value={toExclude}
          onChange={handleChange}
        />
      </FormControl>
    </Box>
  );
}

export default ExcludeFormControl;
